import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Language } from 'app/model/constant';
import { LANG_TH_TRANS } from 'translation/lang-th';
import { LANG_EN_TRANS } from 'translation/lang-en';

@Pipe({
  name: 'translateSingularPlural',
  pure: false
})
export class TranslateSingularPluralPipe implements PipeTransform {
  constructor(private appConfigService: AppConfigService) {}

  transform(value: any, args?: any): any {
    switch (this.appConfigService.getLanguage()) {
      case Language.th:
        return LANG_TH_TRANS[value];
      case Language.en:
        let txt = LANG_EN_TRANS[value];
        if (args > 1) {
          if (value === 'booking-my-child') {
            return LANG_EN_TRANS['booking-my-children'];
          } else if (value === 'cart-child') {
            return LANG_EN_TRANS['cart-children'];
          } else if (value === 'checkout-1-max-child-title') {
            return LANG_EN_TRANS['checkout-1-max-children-title'];
          } else if (value === 'checkout-1-child-title') {
            return LANG_EN_TRANS['checkout-1-children-title'];
          } else if(value === 'booking-detail-details-child') {
            return LANG_EN_TRANS['booking-detail-details-children'];
          }
          txt = txt + 's';
        }
        return txt;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/translate-singular-plural.pipe.ts